<template>
  <b-modal id="modal-import-result" v-model="visible" size="md" :title="title" centered>
    <div class="text-center mb-4">
      <div class="text-center">
        <p style="text-align: center">
          <strong>Số bản ghi thành công:</strong>
          {{ importResultData?.countSuccess || 0 }}
        </p>
        <p style="text-align: center">
          <strong>Số bản ghi thất bại:</strong>
          {{ importResultData?.countError || 0 }}
        </p>
      </div>
      <button
        v-if="importResultData.countError"
        style="font-weight: 400"
        class="btn btn-outline-danger mt-2"
        @click="downloadErrorFile(importResultData.errors)"
      >
        Tải bản ghi thất bại
      </button>
    </div>

    <template #modal-footer>
      <button class="btn btn-primary" @click="visible = false">OK</button>
    </template>
  </b-modal>
</template>
<script>
  import { DeviceService } from '@/services/device.service'
  import { showMess } from '@/config/utils'
  export default {
    data() {
      return {
        visible: false,
        title: 'Nhập file thành công',
        importResultData: {},
      }
    },
    methods: {
      closeModal() {
        this.visible = false
      },
      openModal(payload) {
        this.visible = true
        this.importResultData = { ...payload }
      },
      async downloadErrorFile(fileError) {
        try {
          await DeviceService.exportErrorSimDevice(fileError)
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.visible = false
        }
      },
    },
  }
</script>
